// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Apply = require("../Control.Apply/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Effect = require("../Effect/index.js");
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Node_Buffer = require("../Node.Buffer/index.js");
var Node_Buffer_Class = require("../Node.Buffer.Class/index.js");
var Node_Buffer_Types = require("../Node.Buffer.Types/index.js");
var Random_Hash = require("../Random.Hash/index.js");
var Ints = (function () {
    function Ints(value0, value1, value2, value3, value4, value5, value6, value7) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
        this.value7 = value7;
    };
    Ints.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return function (value6) {
                                return function (value7) {
                                    return new Ints(value0, value1, value2, value3, value4, value5, value6, value7);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    return Ints;
})();
var Doubles = (function () {
    function Doubles(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    Doubles.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new Doubles(value0, value1, value2, value3);
                };
            };
        };
    };
    return Doubles;
})();
var Blob = function (x) {
    return x;
};
var writeInt32LE = function (d) {
    return function (i) {
        return function (b) {
            return Node_Buffer_Class.write(Node_Buffer.mutableBufferEffect)(Node_Buffer_Types.Int32LE.value)(Extra_Math.toNumber(Extra_Math.realInt)(d))(i)(b);
        };
    };
};
var toDoubles = function (v) {
    return Effect_Unsafe.unsafePerformEffect(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Doubles.create)($foreign.readDouble(0)(v)))($foreign.readDouble(8)(v)))($foreign.readDouble(16)(v)))($foreign.readDouble(24)(v)));
};
var readInt32LE = function (i) {
    return function (b) {
        return Data_Functor.map(Effect.functorEffect)(Data_Int.floor)(Node_Buffer_Class.read(Node_Buffer.mutableBufferEffect)(Node_Buffer_Types.Int32LE.value)(i)(b));
    };
};
var toInts = function (v) {
    return Effect_Unsafe.unsafePerformEffect(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Ints.create)(readInt32LE(0)(v)))(readInt32LE(4)(v)))(readInt32LE(8)(v)))(readInt32LE(12)(v)))(readInt32LE(16)(v)))(readInt32LE(20)(v)))(readInt32LE(24)(v)))(readInt32LE(28)(v)));
};
var perturb = function (v) {
    return Random_Hash.hash(Random_Hash.SHA256.value)(v);
};
var merge = function (v) {
    return function (v1) {
        return Blob(Random_Hash.hash(Random_Hash.SHA256.value)(Effect_Unsafe.unsafePerformEffect(Node_Buffer_Class.concat(Node_Buffer.mutableBufferEffect)([ v, v1 ]))));
    };
};
var fromInts = function (v) {
    return Effect_Unsafe.unsafePerformEffect(function __do() {
        var buffer = Node_Buffer_Class.create(Node_Buffer.mutableBufferEffect)(32)();
        writeInt32LE(v.value0)(0)(buffer)();
        writeInt32LE(v.value1)(4)(buffer)();
        writeInt32LE(v.value2)(8)(buffer)();
        writeInt32LE(v.value3)(12)(buffer)();
        writeInt32LE(v.value4)(16)(buffer)();
        writeInt32LE(v.value5)(20)(buffer)();
        writeInt32LE(v.value6)(24)(buffer)();
        writeInt32LE(v.value7)(28)(buffer)();
        return buffer;
    });
};
module.exports = {
    Ints: Ints,
    Doubles: Doubles,
    fromInts: fromInts,
    toInts: toInts,
    toDoubles: toDoubles,
    merge: merge,
    perturb: perturb
};
